import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="Mind Aspirants"
      productUrl="/products/mind-aspirant"
      title="Terms of Service"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          These Terms govern your use of the Mind Aspirants app developed by <strong>Spurnest Techlabs</strong>. By using the app, you agree to these Terms.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Eligibility</SectionTitle>
        <List>
          <li>You must be at least 13 years old to use Mind Aspirants.</li>
          <li>Cash prize features require you to be 18 years or older and a resident of India.</li>
          <li>One account per person. Multiple accounts may result in suspension.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Quiz Participation</SectionTitle>
        <Paragraph>
          Mind Aspirants offers live quizzes with entry fees (e.g. ₹10 per quiz). By paying an entry fee and joining a quiz, you agree to the quiz rules and prize distribution for that event.
        </Paragraph>
        <Paragraph>Entry fees are non-refundable once a quiz has started.</Paragraph>
      </Section>

      <Section>
        <SectionTitle>Prize Distribution</SectionTitle>
        <Paragraph>
          Prizes are distributed based on the published prize breakout table for each quiz. Rankings are determined by points earned and time taken. Spurnest Techlabs and Mind Aspirants reserve the right to verify winners before payout.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Fair Play</SectionTitle>
        <Paragraph>Cheating, use of bots, collusion, or any manipulation of quiz results is strictly prohibited. Violations result in immediate account suspension and forfeiture of prizes.</Paragraph>
      </Section>

      <Section>
        <SectionTitle>Referral Program</SectionTitle>
        <Paragraph>
          Referral rewards are subject to program terms displayed in the app. We reserve the right to modify or discontinue the referral program at any time.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Account Suspension</SectionTitle>
        <Paragraph>
          We may suspend or terminate accounts that violate these Terms, engage in fraudulent activity, or abuse the platform, without prior notice.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Governing Law</SectionTitle>
        <Paragraph>
          These Terms are governed by the laws of India. Disputes are subject to courts in Gandhinagar, Gujarat.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Contact</SectionTitle>
        <Paragraph>
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
